import React, { FC } from 'react';
import { PageHeader, SearchComponent, UserStateComponent } from '../../../components';
import { useTranslation } from '../../../translations';

export const UserSearch: FC = () => {
  const { ts } = useTranslation();
  return (
    <UserStateComponent>
      <PageHeader>{ts('user_search')}</PageHeader>
      <SearchComponent />
    </UserStateComponent>
  );
};
